import React, { useState, useEffect, useRef } from 'react';
import { /*Redirect,*/ Route, Switch, useLocation } from 'react-router-dom';

import './App.css';

// import Swal from 'sweetalert2'

// import ASSEC_Helmet from './components/Pagina/ASSEC_Helmet/ASSEC_Helmet_async';

import useToken from './UseToken';
import { getTokenInfo } from './UseToken';

import RequestUnsubscribeNL from "./components/Pagina/Forms/RequestUnsubscribeNL";

// import Preview from './components/Pagina/Preview/Preview';
import Confirm from './components/Pagina/WEBContent/Confirm/Confirm';

// import Pagina from './components/Pagina/Pagina';
import Pagina_01 from './components/Pagina/Pagina_01';
import Pagina_02 from './components/Pagina/Pagina_02';
import Pagina_03 from './components/Pagina/Pagina_03';
import Pagina_04 from './components/Pagina/Pagina_04';
import Pagina_05 from './components/Pagina/Pagina_05';
import Pagina_06 from './components/Pagina/Pagina_06';
import Pagina_07 from './components/Pagina/Pagina_07';
import Pagina_08 from './components/Pagina/Pagina_08';
import Pagina_09 from './components/Pagina/Pagina_09';
import Pagina_10 from './components/Pagina/Pagina_10';


import Cookies from "./components/Pagina/Cookies/Cookies";
import GoTopButton from './components/Pagina/GoTopButton/GoTopButton';

import Content from './components/Pagina/Content/Content';

import Loader from './loader'

import * as Hosts from './Hosts';

// import { language } from './components/Pagina/WEBContent/Language';

import {
  repo_favicon_link,
  reqGET,
  reqPOST,
  reqDELETE,
  reqPUT,
  set_language,
  // translate,
  // functionSendMail
} from './Utils';


function App() {
	const [, set_dados] = useState(null);
	const dados_config = useRef(null);
	const nl_entity_uid = useRef('');
  
  const { pathname } = useLocation();

  const { setToken } = useToken();

  // const [, set_is_loading] = useState(true)

  const [maintenance, set_maintenance] = useState(true)
  const [available, set_available] = useState(false)
  const [template, set_template] = useState({})
  const [theme, set_theme] = useState({})
  // const [dados_config, set_dados_config] = useState({})
  
  const [empty_page, set_empty_page] = useState(false)

  const handleFavIcon = (url) => {
    function getFaviconEl() {
      return document.getElementById("favicon");
    }
    const favicon = getFaviconEl(); // Accessing favicon element
    
    if(url !== undefined && url !== '') {
      favicon.href = url;
    }
    else {
      favicon.href = repo_favicon_link("favicon.ico");
    }

  };

  //LOADER TIMEOUT
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.process = {
      ...window.process,
    };
  }, []);

  useEffect(() => {
    if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null) {
      set_language('pt')
    }

    setToken({ "token_site": Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN })

    const timer = setTimeout(() => {
      setIsLoading(false);
      //setCount('Timeout called!');
    }, 500);

    return () => clearTimeout(timer);

    /*    setTimeout(() => {
        setIsLoading(false);
      }, 500);  */
  }, [setToken])

  useEffect(() => {

    (async () => {
      // await aux_func()
      // window.addEventListener("focus", async() => await on_init(set_is_loading));
      //console.error('history.action', history.action)

    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {

    const getConfig = async (id, uid) => {

      if((id !== undefined && id !== null && id !== '') || (uid !== undefined && uid !== null && uid !== '')) {

        let res = {data: []}

        if(id !== undefined && id !== null && id !== '') {
          res = await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${id}`)
        }
        else if(uid !== undefined && uid !== null && uid !== '') {
          res = await reqGET(`${Hosts.SIMCore_API}/web/content/uniqid/${Hosts.companycode}/${uid}`)
        }

        if(res.data.length > 0) {
          set_template(res.data[0].info.template !== undefined && res.data[0].info.template.id !== undefined ? res.data[0].info.template : {info: {tag: ''}})
          set_theme(res.data[0].info.theme !== undefined && res.data[0].info.theme.id !== undefined ? res.data[0].info.theme : {info: {tag: ''}})
          set_maintenance(res.data[0].info.maintenance)
          set_available(res.data[0].info.available)
          set_dados(dados_config.current = res.data[0])

          document.getElementById("head_style").innerHTML = ":root { --primary: " + res.data[0].info.theme.info.color.primary + " !important; --primary-rgb: " + res.data[0].info.theme.info.color.primary_rgb + " !important; --secondary: " + res.data[0].info.theme.info.color.secondary + " !important; }";

          if(res.data[0].content[0].favicon.url !== undefined && res.data[0].content[0].favicon.url !== '') {
            handleFavIcon(res.data[0].content[0].favicon.url)
          }
          else {
            handleFavIcon()
          }
        }
        else {
          set_template({info: {tag: ''}})
          set_theme({info: {tag: ''}})
          set_maintenance(true)
          set_available(false)
          set_dados(dados_config.current = {info: {maintenance: true, available: false}})

          handleFavIcon()
        }
      }
      else {

        set_template({info: {tag: 'container-fluid'}})
        set_theme({info: {tag: ''}})
        set_maintenance(false)
        set_available(false)
        set_dados(dados_config.current = {info: {maintenance: false, available: false}})

        set_empty_page(true)

        handleFavIcon()

      }
    }
    
    (async () => {

      if((getTokenInfo()?.profile.includes('Administrador') || getTokenInfo()?.profile.includes('Gestor')) && pathname.includes('/preview/')) {
        let id_aux = pathname.split('/').pop()
        if(id_aux !== '') {
          await getConfig(id_aux, '')
        }

      }
      else if(pathname.includes('/nl/')) {

        let aux_path_params = pathname.split('/nl/')
        aux_path_params = aux_path_params[1].split('/')
        if(aux_path_params[1] !== null && aux_path_params[1] !== '') {
          let nl_uid = aux_path_params[0]
          // let entity_uid = aux_path_params[1]

          await getConfig('', nl_uid)
          
          set_maintenance(true)
          set_available(false)
          set_empty_page(true)
        }
        else {
          let nl_uid = aux_path_params[0]

          await getConfig('', nl_uid)

        }

      }
      else if(pathname.includes('/link/')) {
 
        let aux_path_params = pathname.split('/link/')
        aux_path_params = aux_path_params[1].split('/')

        if(aux_path_params[4] !== undefined && aux_path_params[4] !== null && aux_path_params[4] !== '') {

          let type = aux_path_params[0]
          let order = aux_path_params[1]
          let nl_img_order = aux_path_params[2]
          // let nl_uid = aux_path_params[3]
          let entity_uid = aux_path_params[4]
          set_dados(nl_entity_uid.current = aux_path_params[4])

          let l = '' 

          await getConfig('', aux_path_params[3])

          if(type === 'fv') {
            l = dados_config.current.content[0]?.contacts?.link
          }
          else if(type === 'fl') {

            if(nl_img_order === '*') {
              l = dados_config.current.content[0].floating[order]?.info?.link[0]?.pt
            }
            else {
              l = dados_config.current.content[0].floating[order]?.info?.media?.image[nl_img_order]?.url
            }

          }
          else if(type === 'sn') {
            l = dados_config.current.content[0].social[order]?.info?.link
          }

          console.log('l', l)

          let res_nl_log = await reqGET(`${Hosts.SIMCore_API}/web/nl/log/entity/uid/${Hosts.companycode}/${entity_uid}`)

          console.log('res_nl_log', res_nl_log)

          if(res_nl_log.data !== undefined && res_nl_log.data.length > 0 && type !== 'un') {
            let today_nl = new Date();
            // let aux_today_nl = today_nl.getFullYear() + '-' + (today_nl.getMonth() + 1).toString().padStart(2, '0') + '-' + today_nl.getDate().toString().padStart(2, '0') + 'T' + today_nl.getHours().toString().padStart(2, '0') + ':' + today_nl.getMinutes().toString().padStart(2, '0')

            if(res_nl_log.data[0]?.info?.date?.read === '') {
              res_nl_log.data[0].info.date.read = today_nl
              res_nl_log.data[0].info.state = 2
            }
            if(res_nl_log.data[0]?.info?.date?.interaction === '') {
              res_nl_log.data[0].info.date.interaction = today_nl
              res_nl_log.data[0].info.state = 3
            }

            await reqPUT(`${Hosts.SIMCore_API}/web/nl/log`, res_nl_log.data[0])
          }
          else if(res_nl_log.data !== undefined && res_nl_log.data.length > 0 && type === 'un') {

            let today_nl = new Date();

            if(res_nl_log.data[0]?.info?.date?.read === '') {
              res_nl_log.data[0].info.date.read = today_nl
              res_nl_log.data[0].info.state = 2
            }
            if(res_nl_log.data[0]?.info?.date?.interaction === '') {
              // res_nl_log.data[0].info.date.interaction = today_nl
              // res_nl_log.data[0].info.state = 3
            }

            await reqPUT(`${Hosts.SIMCore_API}/web/nl/log`, res_nl_log.data[0])

            let nl_unsubscribe = {
              id: '',
              info: {
                companycode: Hosts.companycode,
                date: today_nl,
                entity: {
                  id: res_nl_log.data[0].info.entity.id,
                  uniqid: res_nl_log.data[0].info.entity.uniqid,
                  email: res_nl_log.data[0].info.entity.email,
                  name: res_nl_log.data[0].info.entity.name,
                },
                state: 0
              }
            }

            await reqPOST(`${Hosts.SIMCore_API}/web/nl/unsubscribe/${Hosts.companycode}/entity`, nl_unsubscribe)
            await reqDELETE(`${Hosts.SIMCore_API}/web/nl/unsubscribe/${Hosts.companycode}/entity/forget`, nl_unsubscribe)

            // l = dados_config.current.content[0]?.contacts?.link
            l = Hosts.EMAIL_WEB_SITE_URL + '/unsubscribe/nl'

          }

          if(l.includes('http')) {
            window.location.href = l;
          }
          else {
            window.location.href = 'https://' + l;
          }
          
        }
        else if(aux_path_params[3] !== undefined && aux_path_params[3] !== null && aux_path_params[3] !== '') {

          console.log('2 aux_path_params', aux_path_params)

          let type = aux_path_params[0]
          let order = aux_path_params[1]
          let nl_img_order = aux_path_params[2]
          // let nl_uid = aux_path_params[3]
          // let entity_uid = aux_path_params[4]
          set_dados(nl_entity_uid.current = aux_path_params[4])

          let l = ''

          await getConfig('', aux_path_params[3])

          if(type === 'fv') {
            l = dados_config.current.content[0]?.contacts?.link
          }
          else if(type === 'fl') {

            if(nl_img_order === '*') {
              l = dados_config.current.content[0].floating[order]?.info?.link[0]?.pt
            }
            else {
              l = dados_config.current.content[0].floating[order]?.info?.media?.image[nl_img_order]?.url
            }

          }
          else if(type === 'sn') {
            l = dados_config.current.content[0].social[order]?.info?.link
          }
          else if(type === 'un') {
            // l = dados_config.current.content[0]?.contacts?.link
            l = Hosts.EMAIL_WEB_SITE_URL + '/unsubscribe/nl'

            // await Swal.fire({
            //   icon: 'info',
            //   html: language['pt'].nl_unsubscribe_success,
            //   showConfirmButton: false,
            //   timer: 3000
            // })

          }

          if(l.includes('http')) {
            window.location.href = l;
          }
          else {
            window.location.href = 'https://' + l;
          }
        }

      }
      else {
        await getConfig('', '')
      }

    })()

  }, [pathname])

  return isLoading ?
    <Loader />
  :
    <>
      {
      empty_page ? 
        null
      :
        <Cookies item={{template: template?.info?.tag, theme: theme?.info?.tag, dados_config: dados_config.current}} />
      }
      <GoTopButton item={{template: template?.info?.tag, theme: theme?.info?.tag}} />
     
      <main className={template?.info?.tag + ' ' + theme?.info?.tag}>
        <Switch>
          <Route path={"/unsubscribe/nl"} component={RequestUnsubscribeNL} exact={true} />

          {
          ((maintenance || !available) && pathname.includes('/preview/')) || ((getTokenInfo()?.profile.includes('Administrador') || getTokenInfo()?.profile.includes('Gestor')) && pathname.includes('/preview/')) ?
            <>
              {/* <Preview /> */}
              {
              template?.info?.tag === 'page-01' ?
                <Route path='/preview/:id_preview' exact component={Pagina_01} />
              :
              template?.info?.tag === 'page-02' ?
                <Route path='/preview/:id_preview' exact component={Pagina_02} />
              :
              template?.info?.tag === 'page-03' ?
                <Route path='/preview/:id_preview' exact component={Pagina_03} />
              :
              template?.info?.tag === 'page-04' ?
                <Route path='/preview/:id_preview' exact component={Pagina_04} />
              :
              template?.info?.tag === 'page-05' ?
                <Route path='/preview/:id_preview' exact component={Pagina_05} />
              :
              template?.info?.tag === 'page-06' ?
                <Route path='/preview/:id_preview' exact component={Pagina_06} />
              :
              template?.info?.tag === 'page-07' ?
                <Route path='/preview/:id_preview' exact component={Pagina_07} />
              :
              template?.info?.tag === 'page-08' ?
                <Route path='/preview/:id_preview' exact component={Pagina_08} />
              :
              template?.info?.tag === 'page-09' ?
                <Route path='/preview/:id_preview' exact component={Pagina_09} />
              :
              template?.info?.tag === 'page-10' ?
                <Route path='/preview/:id_preview' exact component={Pagina_10} />
              :
                <Route component={Content} />
              }
              <Confirm item={{dados_config: dados_config.current}} />
            </>
          :
          pathname.includes('/link/') ?
            <></>
          :
          (!maintenance && available) && pathname.includes('/nl/') ?
              template?.info?.tag === 'page-01' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_01} />
              :
              template?.info?.tag === 'page-02' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_02} />
              :
              template?.info?.tag === 'page-03' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_03} />
              :
              template?.info?.tag === 'page-04' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_04} />
              :
              template?.info?.tag === 'page-05' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_05} />
              :
              template?.info?.tag === 'page-06' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_06} />
              :
              template?.info?.tag === 'page-07' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_07} />
              :
              template?.info?.tag === 'page-08' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_08} />
              :
              template?.info?.tag === 'page-09' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_09} />
              :
              template?.info?.tag === 'page-10' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_10} />
              :
                null
            : 
            (!maintenance && available) && pathname.includes('/nl/') ?
              template?.info?.tag === 'page-01' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_01} />
              :
              template?.info?.tag === 'page-02' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_02} />
              :
              template?.info?.tag === 'page-03' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_03} />
              :
              template?.info?.tag === 'page-04' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_04} />
              :
              template?.info?.tag === 'page-05' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_05} />
              :
              template?.info?.tag === 'page-06' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_06} />
              :
              template?.info?.tag === 'page-07' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_07} />
              :
              template?.info?.tag === 'page-08' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_08} />
              :
              template?.info?.tag === 'page-09' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_09} />
              :
              template?.info?.tag === 'page-10' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:uid/:euid', '/nl/:uid/:euid']} exact component={Pagina_10} />
              :
                null
            :
            pathname.includes('/nl/') ?
              template?.info?.tag === 'page-01' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:euid', '/nl/:euid']} exact component={Pagina_01} />
              :
              template?.info?.tag === 'page-02' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:euid', '/nl/:euid']} exact component={Pagina_02} />
              :
              template?.info?.tag === 'page-03' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:euid', '/nl/:euid']} exact component={Pagina_03} />
              :
              template?.info?.tag === 'page-04' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:euid', '/nl/:euid']} exact component={Pagina_04} />
              :
              template?.info?.tag === 'page-05' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:euid', '/nl/:euid']} exact component={Pagina_05} />
              :
              template?.info?.tag === 'page-06' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:euid', '/nl/:euid']} exact component={Pagina_06} />
              :
              template?.info?.tag === 'page-07' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:euid', '/nl/:euid']} exact component={Pagina_07} />
              :
              template?.info?.tag === 'page-08' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:euid', '/nl/:euid']} exact component={Pagina_08} />
              :
              template?.info?.tag === 'page-09' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:euid', '/nl/:euid']} exact component={Pagina_09} />
              :
              template?.info?.tag === 'page-10' ?
                <Route path={[Hosts.APPLICATION_URL + 'nl/:euid', '/nl/:euid']} exact component={Pagina_10} />
              :
                null
            :
              <Route component={Content} />
          }

          {/*
          <Redirect to="/" />
          */}

        </Switch >
      </main>
    </>
}

export default App;
